const initialState = {
  isLoadingUsers: false,
  errorUsers: false,
  successUsers: false,
  dataUsers: false,
  og_dataUsers: false,
};
export const usersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "USERS_LOADING":
      return {
        ...state,
        isLoadingUsers: true,
      };
    case "USERS_FETCH_ADMIN_SUCCESS":
      return {
        ...state,
        isLoadingUsers: false,
        errorUsers: false,
        dataUsers: payload.data,
        og_dataUsers: payload.data,
        successUsers: payload.message,
      };
    case "USERS_FILTER_SUCCESS":
      return {
        ...state,
        isLoadingUsers: false,
        errorUsers: false,
        dataUsers: payload.data,
        successUsers: payload.message,
      };
    case "USERS_ADMIN_SUCCESS":
      return {
        ...state,
        isLoadingUsers: false,
        errorUsers: false,
        successUsers: payload.message,
      };
    case "USERS_ERROR":
      return {
        ...state,
        isLoadingUsers: false,
        errorUsers: payload,
        successUsers: false,
      };
    case "USERS_RESET_MESSAGE":
      return {
        ...state,
        successUsers: false,
        errorUsers: false,
      };
    case "USERS_FAKE_RESET":
      return {
        ...initialState,
      };
    case "DISCONNECT":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
